<template>
    <section class="quiz__campaign__landing" :class="{ 'quiz__campaign__landing-active' : landing_active, 'quiz__campaign__landing-no-image' : campaign.desktop_media_id === null }">
        <div v-if="campaign.desktop_media_id" class="quiz__campaign__landing-header">
            <a href="#" @click.prevent="scrollDownPage" class="quiz__campaign__landing-header-scroll">Scroll Down</a>
            <img :src="campaign.mobile_media" :alt="campaign.name" class="quiz__campaign__landing-header-mobile-image" />
            <img :src="campaign.desktop_media" :alt="campaign.name" class="quiz__campaign__landing-header-image" />
        </div>
        <div class="quiz__campaign__landing-content">
            <div class="quiz__campaign__landing-content-text">
                <h1 class="quiz__camapign__landing-title" v-html="campaign.name"></h1>
                <div>
                    <div class="quiz__campaign__landing-text" v-html="campaign.content"></div>
                    <a class="quiz__campaign-button quiz__campaign-start" @click.prevent="startQuiz" href="" v-html="campaign.button_text"></a>
                </div>
            </div>
            <div class="quiz__campaign__landing-decoration">
                <img v-if="campaign.all_media.item_1 !== null" :src="campaign.all_media.item_1.image_urls.large" :alt="campaign.all_media.item_1.alt_text" class="quiz__campaign__landing-decoration-image_1" />
                <img v-if="campaign.all_media.item_2 !== null" :src="campaign.all_media.item_2.image_urls.large" :alt="campaign.all_media.item_2.alt_text"  class="quiz__campaign__landing-decoration-image_2" />
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        props: ['campaign'],
        methods: {
            scrollDownPage() {
                $(document).ready(function(){
                    let winHeight =  $(window).height();
                    let buttonTop = $('.quiz__campaign__landing-content .quiz__campaign-button').offset().top;
                    let anchorPoint = ((buttonTop + 100) - winHeight);

                    $('html, body').animate({ scrollTop: anchorPoint +'px' }, 300);


                });
            },
            startQuiz() {
                Event.$emit('start_quiz');
                this.landing_active = false;
                scroll(0,0);
            }
        },
        data() {
            return {
                landing_active : true
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/quiz-campaign/components/landing.vue